import { render, staticRenderFns } from "./ReportDocumentSignRequestForm.vue?vue&type=template&id=0352be65&scoped=true&"
import script from "./ReportDocumentSignRequestForm.vue?vue&type=script&lang=ts&"
export * from "./ReportDocumentSignRequestForm.vue?vue&type=script&lang=ts&"
import style0 from "./ReportDocumentSignRequestForm.vue?vue&type=style&index=0&id=0352be65&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0352be65",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCardActions,VCardText,VIcon})
